const COPY: Record<string, { title: string; detail: string }> = {
  disabled: { title: '240 Profile is unavailable right now.', detail: 'Please check back later. Links to profiles still work once it is back.' },
  session_invalid: { title: 'We could not verify your sign-in.', detail: 'Refresh the page to sign in again.' },
};
const FALLBACK = { title: 'We could not load 240 Profile.', detail: 'Check your connection and try again in a moment.' };

/** Profile switched off (R13, KTD8), a sign-in that expired, or a Worker that did not answer. */
export function Unavailable({ reason, onRetry }: { reason: string; onRetry?(): void }) {
  // Own keys only, so a reason like `toString` falls back instead of reading the prototype.
  const { title, detail } = Object.hasOwn(COPY, reason) ? COPY[reason]! : FALLBACK;
  return <section className="notice" role="alert"><h2>{title}</h2><p>{detail}</p>{onRetry && <button className="secondary" onClick={onRetry}>Try again</button>}</section>;
}
